import factory from './icon';
import Svg12x12 from './glyphs/Minus_12x12.svg';
import Svg16x16 from './glyphs/Minus_16x16.svg';
import Svg24x24 from './glyphs/Minus_24x24.svg';

export const Minus12x12 = factory(Svg12x12, 12, 12);
export const Minus16x16 = factory(Svg16x16, 16, 16);
export const Minus24x24 = factory(Svg24x24, 24, 24);